import { connect } from 'react-redux';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import storeService from '@services/store';

import { showErrorMessage, showSuccessMessage } from '@actions/messageconfirmation';

import { getClientInfo } from '@selectors/client';

import ExportModalContent from '@lib/inpulse/ExportModal';

const ProgressBarModal = (props) => {
  const {
    closeModal,
    showSuccessMessage,
    showErrorMessage,
    params: { stores, storeIdReference, setModalStep, closeModalCleanUp },
  } = props;

  const [isLoading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [title, setTitle] = useState(i18next.t('ADMIN.STORES.TIME_SLOTS_DUPLICATION_IN_PROGRESS'));

  useEffect(() => {
    if (!stores || !stores.length || !storeIdReference) {
      return;
    }

    duplicateStoreTimeSlots(stores, storeIdReference);
  }, [stores, storeIdReference]);

  const duplicateStoreTimeSlots = async (stores, storeIdReference) => {
    const storeIds = stores.map(({ id }) => id);

    try {
      await storeService.duplicateProductionTimeSlots(storeIdReference, storeIds);

      // Update progress as complete
      setProgress(100);

      timeSlotsSetupSuccess();

      showSuccessMessage(i18next.t('ADMIN.STORES.TIME_SLOTS_DUPLICATION_SUCCESS'));
    } catch {
      showErrorMessage(i18next.t('ADMIN.STORES.TIME_SLOTS_DUPLICATION_FAILURE'));

      timeSlotsSetupFailure();
    }
  };

  const exitModal = () => {
    setLoading(false);

    closeModal();

    if (closeModalCleanUp) {
      closeModalCleanUp();
    }

    setModalStep(null);
  };

  const timeSlotsSetupSuccess = () => {
    setTitle(i18next.t('ADMIN.STORES.TIME_SLOTS_DUPLICATION_SUCCESS_TITLE'));
    setLoading(false);
  };

  const timeSlotsSetupFailure = () => {
    setTitle(i18next.t('ADMIN.STORES.TIME_SLOTS_DUPLICATION_FAILURE_TITLE'));
    setLoading(false);
  };

  return (
    <ExportModalContent
      {...props}
      closeModal={closeModal}
      exitModal={exitModal}
      isLoading={isLoading}
      progress={progress}
      setLoading={setLoading}
      titleModal={title}
    />
  );
};

const mapStateToProps = (state) => ({
  client: getClientInfo(state.baseReducer.user),
});

const mapDispatchToProps = (dispatch) => ({
  showSuccessMessage: (message) => {
    dispatch(showSuccessMessage(message));
  },
  showErrorMessage: (message) => {
    dispatch(showErrorMessage(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBarModal);
